import axiosInstance from "../../config/Axios";

export const getStocks = async ({ page = 1, limit = 10, product, ...filters } = {}) => {
  try {
    const offset = (page - 1) * limit;
    const response = await axiosInstance({
      method: "get",
      url: "/api/duka/oaf-stock/",
      params: {
        limit,
        offset,
        ...(product && { product }),
        ...filters,
      },
    });
    return {
      data: response.data.results,
      total: response.data.count,
      next: response.data.next,
      previous: response.data.previous
    };
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getStockById = async (id) => {
  try {
    return await axiosInstance({
      method: "get",
      url: `/api/duka/oaf-stock/${id}/`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createStock = async (stockData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/duka/oaf-stock/",
      data: stockData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateStock = async (id, stockData) => {
  try {
    return await axiosInstance({
      method: "put",
      url: `/api/duka/oaf-stock/${id}/`,
      data: stockData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteStock = async (id) => {
  if (!id) {
    return Promise.reject(new Error("Stock ID is required"));
  }
  try {
    const response = await axiosInstance({
      method: "delete",
      url: `/api/duka/oaf-stock/${id}/`,
    });
    return response;
  } catch (error) {
    console.error("Delete API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
};

export default {
  getStocks,
  getStockById,
  createStock,
  updateStock,
  deleteStock,
};
